"use strict";
/**
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var oauth2client_1 = require("./oauth2client");

var UserRefreshClient =
/*#__PURE__*/
function (_oauth2client_1$OAuth) {
  _inherits(UserRefreshClient, _oauth2client_1$OAuth);

  function UserRefreshClient(optionsOrClientId, clientSecret, refreshToken, eagerRefreshThresholdMillis, forceRefreshOnFailure) {
    var _this;

    _classCallCheck(this, UserRefreshClient);

    var opts = optionsOrClientId && typeof optionsOrClientId === 'object' ? optionsOrClientId : {
      clientId: optionsOrClientId,
      clientSecret: clientSecret,
      refreshToken: refreshToken,
      eagerRefreshThresholdMillis: eagerRefreshThresholdMillis,
      forceRefreshOnFailure: forceRefreshOnFailure
    };
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserRefreshClient).call(this, {
      clientId: opts.clientId,
      clientSecret: opts.clientSecret,
      eagerRefreshThresholdMillis: opts.eagerRefreshThresholdMillis,
      forceRefreshOnFailure: opts.forceRefreshOnFailure
    }));
    _this._refreshToken = opts.refreshToken;
    return _this;
  }
  /**
   * Refreshes the access token.
   * @param refreshToken An ignored refreshToken..
   * @param callback Optional callback.
   */


  _createClass(UserRefreshClient, [{
    key: "refreshTokenNoCache",
    value: function () {
      var _refreshTokenNoCache = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(refreshToken) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _get(_getPrototypeOf(UserRefreshClient.prototype), "refreshTokenNoCache", this).call(this, this._refreshToken));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshTokenNoCache(_x) {
        return _refreshTokenNoCache.apply(this, arguments);
      }

      return refreshTokenNoCache;
    }()
    /**
     * Create a UserRefreshClient credentials instance using the given input
     * options.
     * @param json The input object.
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json) {
        throw new Error('Must pass in a JSON object containing the user refresh token');
      }

      if (json.type !== 'authorized_user') {
        throw new Error('The incoming JSON object does not have the "authorized_user" type');
      }

      if (!json.client_id) {
        throw new Error('The incoming JSON object does not contain a client_id field');
      }

      if (!json.client_secret) {
        throw new Error('The incoming JSON object does not contain a client_secret field');
      }

      if (!json.refresh_token) {
        throw new Error('The incoming JSON object does not contain a refresh_token field');
      }

      this._clientId = json.client_id;
      this._clientSecret = json.client_secret;
      this._refreshToken = json.refresh_token;
      this.credentials.refresh_token = json.refresh_token;
    }
  }, {
    key: "fromStream",
    value: function fromStream(inputStream, callback) {
      if (callback) {
        this.fromStreamAsync(inputStream).then(function (r) {
          return callback();
        }, callback);
      } else {
        return this.fromStreamAsync(inputStream);
      }
    }
  }, {
    key: "fromStreamAsync",
    value: function () {
      var _fromStreamAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(inputStream) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  if (!inputStream) {
                    return reject(new Error('Must pass in a stream containing the user refresh token.'));
                  }

                  var s = '';
                  inputStream.setEncoding('utf8').on('error', reject).on('data', function (chunk) {
                    return s += chunk;
                  }).on('end', function () {
                    try {
                      var data = JSON.parse(s);

                      _this2.fromJSON(data);

                      return resolve();
                    } catch (err) {
                      return reject(err);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fromStreamAsync(_x2) {
        return _fromStreamAsync.apply(this, arguments);
      }

      return fromStreamAsync;
    }()
  }]);

  return UserRefreshClient;
}(oauth2client_1.OAuth2Client);

exports.UserRefreshClient = UserRefreshClient;